import { render } from "./NewUserData.vue?vue&type=template&id=f92457aa&scoped=true"
import script from "./NewUserData.vue?vue&type=script&lang=js"
export * from "./NewUserData.vue?vue&type=script&lang=js"

import "./NewUserData.vue?vue&type=style&index=0&id=f92457aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f92457aa"

export default script